import { render, staticRenderFns } from "./karina.vue?vue&type=template&id=5f1ce3ca&scoped=true&"
import script from "./karina.vue?vue&type=script&lang=js&"
export * from "./karina.vue?vue&type=script&lang=js&"
import style0 from "./karina.vue?vue&type=style&index=0&id=5f1ce3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ce3ca",
  null
  
)

export default component.exports